var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTargetSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 43,
    viewBox: "0 0 46 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9665 35.7988C22.6021 35.4151 23.3979 35.4151 24.0335 35.7988L34.392 42.0508C35.9066 42.9649 37.7751 41.607 37.3732 39.8841L34.6243 28.1006C34.4556 27.3776 34.7013 26.6207 35.2624 26.1346L44.4172 18.2038C45.7544 17.0454 45.0396 14.8488 43.2767 14.6993L31.2267 13.677C30.4876 13.6142 29.8438 13.1476 29.5544 12.4646L24.8414 1.34474C24.1523 -0.281317 21.8477 -0.281317 21.1586 1.34474L16.4456 12.4646C16.1562 13.1476 15.5124 13.6142 14.7733 13.677L2.72326 14.6993C0.960409 14.8488 0.245593 17.0454 1.58279 18.2038L10.7376 26.1346C11.2987 26.6207 11.5444 27.3776 11.3757 28.1006L8.62683 39.8841C8.22491 41.607 10.0934 42.9649 11.608 42.0508L21.9665 35.7988Z",
    fill: "#F4C900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetSelected);
export default __webpack_public_path__ + "static/media/TargetSelected.e6cb99cafc9d041b31be01261c9f7c2d.svg";
export { ForwardRef as ReactComponent };